(function (Drupal, $) {
  Drupal.behaviors.MediaSide = {
    attach: function (context) {
      $(once("media-side-processed", ".media-side", context))
        .each(function () {
          function reduceSpacing(elementSelector, bgClass, adjustingMargin = false) {
            var elements = document.querySelectorAll(elementSelector);
            elements.forEach(function(element){
              var nextSibling = element.nextElementSibling;

              if (nextSibling && nextSibling.tagName === 'DIV' && nextSibling.firstElementChild.classList.contains(bgClass)) {
                element.querySelector('.media-side').style.paddingBottom = 0;
              } 

              // adjusting intro panel margin

              if (adjustingMargin) {
                  if (nextSibling && nextSibling.tagName === 'DIV' && (nextSibling.matches(elementSelector) || nextSibling.firstElementChild.classList.contains(bgClass))) {
                    var mediaSide = element.querySelector('.media-side')
                    if (mediaSide.classList.contains('margin-v-7')) {
                      mediaSide.classList.remove('margin-v-7')
                      mediaSide.classList.add('margin-v-4')
                    }
                  }
              }


            });
          }

          reduceSpacing(".paragraph--type--feature-image-panel", "shading-enabled", true);
          reduceSpacing(".paragraph--type--feature-panel-with-side-image", "shading-enabled", false);
        }); // once
    },
  };
})(Drupal, jQuery);
